import { AbstractCommand } from 'src/models/command';

class UpdateTheNotificationConfigurationCommand extends AbstractCommand {
	readonly name = 'IFS_Core_Command_Commands_UpdateTheNotificationConfigurationCommand';

	public constructor(
		notificationsAppointmentEnabled: boolean,
		notificationsMailEnabled: boolean,
		notificationsMessageEnabled: boolean,
		notificationsPhoneCallsEnabled: boolean,
		notificationsTasksEnabled: boolean,
		notificationsNotesEnabled: boolean,
		notificationsDocumentsEnabled: boolean,
		notificationsIdoEnabled: boolean
	) {
		super();
		this.parameters = {
			notificationsAppointmentEnabled: notificationsAppointmentEnabled,
			notificationsDocumentsEnabled: notificationsDocumentsEnabled,
			notificationsIdoEnabled: notificationsIdoEnabled,
			notificationsMailEnabled: notificationsMailEnabled,
			notificationsMessageEnabled: notificationsMessageEnabled,
			notificationsNotesEnabled: notificationsNotesEnabled,
			notificationsPhoneCallsEnabled: notificationsPhoneCallsEnabled,
			notificationsTasksEnabled: notificationsTasksEnabled,
		};
	}
}

export { UpdateTheNotificationConfigurationCommand };
